var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"align":"center","no-gutter":"","dense":""}},[_c('v-col',{staticClass:"mb-3",attrs:{"cols":"12"}},[_c('div',{staticClass:"primary--text text-caption font-weight-bold d-flex align-center"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }